import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col, Card } from "react-bootstrap";
import { API_BASE_URL } from "../../services/api";
import Loader from "../Common/Loader";
import {
  TextField,
  InputAdornment,
  IconButton,
  Avatar,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  FormHelperText,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import { Camera } from "react-feather";
import { useFormik } from "formik";
import * as Yup from "yup";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import "./Profile.css";
import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import AdminChangePassword from "./AdminChangePassword";
import { AccessLog } from "../../Utils/AccessLog";

const Profile = () => {
  const [profileImage, setProfileImage] = useState("");
  const [profilePreview, setProfilePreview] = useState("");
  const [profileDetails, setProfileDetails] = useState({});
  const [companyCountryCode, setCompanyCountryCode] = useState("");
  const [phoneCountryCode, setPhoneCountryCode] = useState("");
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleImageUpload = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        toast.info("File size exceeds 2 MB. Please upload a smaller file.");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImage(reader.result);
        setProfilePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  console.log("profileDetails-->", profileDetails);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: profileDetails?.first_name || "",
      lastName: profileDetails?.last_name || "",
      email: profileDetails?.email || "",
      phone: profileDetails?.phone || "",
      companyName: profileDetails?.company_name || "",
      companyPhone: profileDetails?.company_phone || "",
      numberOfEmployees: profileDetails?.number_of_employees || "",
      customerType: profileDetails?.customer_type || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      phone: Yup.string()
        .matches(/^\d{10}$/, "Phone must be 10 digits")
        .required("Phone is required"),
      companyName: Yup.string().required("Company name is required"),
      numberOfEmployees: Yup.number()
        .positive()
        .integer(),
        // .required("Number of employees is required"),
      customerType: Yup.string().required("Customer type is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Data", values);
      handleProfileUpdateAPI(values);
    },
  });

  const handleProfileUpdateAPI = async (values) => {
    try {
      setLoading(true);
      const payload = {
        first_name: encryptData(values?.firstName),
        last_name: encryptData(values?.lastName),
        email: encryptData(values?.email),
        company_name: encryptData(values?.companyName),
        company_phone: encryptData(values?.companyPhone),
        company_phone_country_code: companyCountryCode?.toString(),
        number_of_employees: encryptData(values?.numberOfEmployees?.toString()),
        photo: profileImage,
      };

      const authToken = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const response = await apiRequest(
        "web_api/admin/updateProfileDetails",
        "POST",
        payload,
        headers
      );

      if (response?.data?.status_code == 200) {
        setLoading(false);
        fetchProfileDetails();
        setTimeout(() => {
          toast.success(response?.data?.message);
          // setSubmitting(false);
        }, 100);
      } else {
        setLoading(false);
        toast.error(response?.data?.message || "An unexpected error occurred.");
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response?.data?.message || "Login failed. Please try again."
      ); // Handle specific error messages from API
    } finally {
      setLoading(false);
    }
  };

  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      setSelectedPremise(selected);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const fetchProfileDetails = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      const customerDetails = JSON.parse(
        localStorage.getItem("customerDetails")
      );
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `web_api/admin/getProfileDetails?email=${encryptData(
          customerDetails?.email
        )}`,
        "GET",
        null,
        headers
      );

      if (
        userResponse?.data?.status_code === 200 &&
        userResponse?.data?.data?.userData
      ) {
        const user_details = userResponse.data?.data?.userData;
        console.log("user_details--->", user_details);
        setProfilePreview(user_details?.user_image);
        setProfileImage("");
        setProfileDetails(user_details);
        setPhoneCountryCode(user_details?.phone_no_country_code);
        setCompanyCountryCode(
          user_details?.company_phone_country_code
            ? user_details?.company_phone_country_code
            : user_details?.phone_no_country_code
        );

        const customerAccountId = user_details?.customer_account_id;
        const companyName = user_details?.company_name;
        const email = user_details?.email;
        const userId = user_details?.user_id;
        const userImage = user_details?.user_image;
        const authToken = user_details?.token;
        const firstName = user_details?.first_name;
        const lastName = user_details?.last_name;
        localStorage.setItem(
          "customerDetails",
          JSON.stringify({
            customerAccountId,
            companyName,
            userId,
            userImage,
            email,
            firstName,
            lastName,
          })
        );
      } else {
        const user_details = userResponse?.data?.message;
        // toast.error(user_details || "An unexpected error occurred.", {
        //   position: "top-right",
        //   autoClose: 4000,
        // });
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching Users:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  useEffect(() => {
    fetchProfileDetails();
    AccessLog("Profile");
  }, []);

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <Container
            className=""
            style={{
              background: "linear-gradient(135deg, #667eea 100%, #667eea 100%)",
              borderRadius: "20px",
              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Row>
              <Col md={12}>
                <Card
                  className="shadow-lg rounded profileCardMainDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
                    borderRadius: "20px",
                  }}
                >
                  <form onSubmit={formik.handleSubmit}>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        marginBottom: "30px",
                      }}
                    >
                      <h3
                        className="text-primary"
                        style={{
                          fontSize: "25px",
                          fontWeight: "bold",
                          color: "#4a47a3",
                          textShadow: "1px 1px 3px rgba(0,0,0,0.2)",
                        }}
                      ></h3>
                      <div className="text-center position-relative">
                        <Avatar
                          src={profilePreview}
                          sx={{
                            width: 90,
                            height: 90,
                            border: "4px solid #764ba2",
                          }}
                          className="mb-3 shadow-lg"
                        />
                        <label
                          htmlFor="imageUpload"
                          className="position-absolute rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
                          style={{
                            bottom: 0,
                            right: 0,
                            cursor: "pointer",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                            width: "40px",
                            height: "40px",
                          }}
                        >
                          <input
                            type="file"
                            id="imageUpload"
                            accept="image/*"
                            onChange={handleImageUpload}
                            className="d-none"
                          />
                          <Camera size={20} />
                        </label>
                      </div>
                    </div>
                    <Row className="mb-3">
                      <Col md={6} className="inputFiledProfile">
                        <TextField
                          fullWidth
                          size="small"
                          label="First Name"
                          {...formik.getFieldProps("firstName")}
                          error={
                            formik.touched.firstName &&
                            Boolean(formik.errors.firstName)
                          }
                          helperText={
                            formik.touched.firstName && formik.errors.firstName
                          }
                          InputProps={{
                            style: {
                              fontSize: "0.9rem",
                              fontWeight: "600",
                              color: "#444444",
                            }, // Change input text font size, weight, and color
                          }}
                          InputLabelProps={{
                            style: { fontSize: "1rem", color: "#4a90e2" }, // Change label font size, weight, and color
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Last Name"
                          {...formik.getFieldProps("lastName")}
                          error={
                            formik.touched.lastName &&
                            Boolean(formik.errors.lastName)
                          }
                          helperText={
                            formik.touched.lastName && formik.errors.lastName
                          }
                          InputProps={{
                            style: {
                              fontSize: "0.9rem",
                              fontWeight: "600",
                              color: "#444444",
                            }, // Change input text font size, weight, and color
                          }}
                          InputLabelProps={{
                            style: { fontSize: "1rem", color: "#4a90e2" }, // Change label font size, weight, and color
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={6} className="inputFiledProfile viewOptionField">
                        <TextField
                          fullWidth
                          size="small"
                          label="Email"
                          {...formik.getFieldProps("email")}
                          error={
                            formik.touched.email && Boolean(formik.errors.email)
                          }
                          helperText={
                            formik.touched.email && formik.errors.email
                          }
                          InputProps={{
                            style: {
                              fontSize: "0.9rem",
                              fontWeight: "600",
                              color: "#444444",
                            }, // Change input text font size, weight, and
                            readOnly: true,
                            className: "viewOptionField",
                          }}
                          InputLabelProps={{
                            style: { fontSize: "1rem", color: "#4a90e2" }, // Change label font size, weight, and color
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <TextField
                          className="viewOptionField"
                          fullWidth
                          size="small"
                          label="Phone"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography
                                  sx={{
                                    fontSize: ".9rem",
                                    fontWeight: "600",
                                    color: "#6c757d",
                                  }}
                                >
                                  {phoneCountryCode}
                                </Typography>
                              </InputAdornment>
                            ),
                            style: {
                              fontSize: "0.9rem",
                              fontWeight: "600",
                              color: "#444444",
                            }, // Change input text font size, weight, and color
                            readOnly: true,
                            className: "viewOptionField",
                          }}
                          {...formik.getFieldProps("phone")}
                          error={
                            formik.touched.phone && Boolean(formik.errors.phone)
                          }
                          helperText={
                            formik.touched.phone && formik.errors.phone
                          }
                          InputLabelProps={{
                            style: { fontSize: "1rem", color: "#4a90e2" }, // Change label font size, weight, and color
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={6} className="inputFiledProfile">
                        <TextField
                          fullWidth
                          size="small"
                          label="Company Name"
                          {...formik.getFieldProps("companyName")}
                          error={
                            formik.touched.companyName &&
                            Boolean(formik.errors.companyName)
                          }
                          helperText={
                            formik.touched.companyName &&
                            formik.errors.companyName
                          }
                          InputProps={{
                            style: {
                              fontSize: "0.9rem",
                              fontWeight: "600",
                              color: "#444444",
                            }, // Change input text font size, weight, and color
                          }}
                          InputLabelProps={{
                            style: { fontSize: "1rem", color: "#4a90e2" }, // Change label font size, weight, and color
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Company Phone"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography
                                  sx={{
                                    fontSize: ".9rem",
                                    fontWeight: "600",
                                    color: "#444444",
                                  }}
                                >
                                  {companyCountryCode}
                                </Typography>
                              </InputAdornment>
                            ),
                            style: {
                              fontSize: "0.9rem",
                              fontWeight: "600",
                              color: "#444444",
                            }, // Change input text font size, weight, and color
                          }}
                          {...formik.getFieldProps("companyPhone")}
                          helperText={
                            formik.touched.companyPhone &&
                            formik.errors.companyPhone
                          }
                          InputLabelProps={{
                            style: { fontSize: "1rem", color: "#4a90e2" }, // Change label font size, weight, and color
                          }}
                        />
                        <div className="d-flex justify-content-end align-items-center changePasswordDiv">
                          <Button
                            variant="text"
                            className="btn btn-link changeMobileNo"
                            onClick={() => setOpenChangePasswordModal(true)}
                          >
                            Change Password
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-0">
                      <Col md={6} className="inputFiledProfile">
                        <TextField
                          fullWidth
                          size="small"
                          label="Number of Employees"
                          {...formik.getFieldProps("numberOfEmployees")}
                          error={
                            formik.touched.numberOfEmployees &&
                            Boolean(formik.errors.numberOfEmployees)
                          }
                          helperText={
                            formik.touched.numberOfEmployees &&
                            formik.errors.numberOfEmployees
                          }
                          InputProps={{
                            style: {
                              fontSize: "0.9rem",
                              fontWeight: "600",
                              color: "#444444",
                            }, // Change input text font size, weight, and color
                          }}
                          InputLabelProps={{
                            style: { fontSize: "1rem", color: "#4a90e2" }, // Change label font size, weight, and color
                          }}
                        />
                      </Col>
                      <Col md={6}></Col>
                    </Row>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        className="previousBtn btn btn-light"
                        style={{
                          border: "2px solid #dadada",
                        }}
                        type="reset"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="previousBtn premiseNextBtn btn btn-primary"
                        type="submit"
                      >
                        Update
                      </Button>
                    </div>
                  </form>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <Container sx={{ textAlign: "center", mt: 5 }}>
          <AdminChangePassword
            open={openChangePasswordModal}
            onClose={() => setOpenChangePasswordModal(false)}
            setPageLoading={setLoading}
          />
        </Container>
      </div>
    </div>
  );
};

export default Profile;
